import React from 'react';
import { MessageCircleQuestion, Phone } from 'lucide-react';

/**
 * Bottom sticky quick-contact bar: Call us | Enquire now.
 *
 * @param {string} [wrapperClassName] - e.g. "home-navigation-sticky" (+ optional page modifier)
 * @param {string} [phoneHref] - defaults to main site phone from footer
 * @param {(e: React.MouseEvent) => void} [onInquireClick] - e.g. open mailing list modal
 */
const StickyNavigation = ({
  wrapperClassName = '',
  phoneHref = 'tel:+971501627408',
  onInquireClick,
}) => (
  <nav
    className={`sticky-nav-root ${wrapperClassName}`.trim()}
    aria-label="Quick contact"
  >
    <a href={phoneHref} className="sticky-nav-action" aria-label="Call us">
      <Phone className="sticky-nav-icon" aria-hidden size={16} strokeWidth={1.5} />
      <span className="sticky-nav-label">Call us</span>
    </a>
    <span className="sticky-nav-divider" aria-hidden />
    <button type="button" className="sticky-nav-action" onClick={onInquireClick} aria-label="Enquire now">
      <MessageCircleQuestion className="sticky-nav-icon" aria-hidden size={16} strokeWidth={1.5} />
      <span className="sticky-nav-label">Enquire now</span>
    </button>
  </nav>
);

export default StickyNavigation;
